<template>
  <v-row class="scoring-mode-selector mb-5 mt-0 mx-0">
    <v-col
      v-for="(mode, index) in modes"
      class="px-2 py-2"
      cols="12"
      md="4"
      :class="{ 'pl-0': index === 0, 'pr-0': index === modes.length - 1 }"
      :key="mode.id === null ? 'none' : mode.id"
    >
      <v-card
        class="mode-card pa-4"
        min-height="160"
        outlined
        :class="{ 'mode-card--active': isActive(mode.id) }"
        :ripple="false"
        @click="$emit('change', mode.id)"
      >
        <article class="mode-card__layout d-flex align-start">
          <div
            class="mode-card__icon d-flex align-center justify-center mr-3"
            :class="{ 'mode-card__icon--active': isActive(mode.id) }"
          >
            <v-icon size="18" color="white">{{ mode.icon }}</v-icon>
          </div>
          <div class="mode-card__content">
            <span
              class="subtitle2 font-weight-600"
              :class="
                isActive(mode.id)
                  ? 'blue--text'
                  : 'blue-grey--text text--darken-3'
              "
            >
              {{ mode.title }}
            </span>
            <span
              class="text-caption mt-1 d-block"
              :class="{
                'blue--text': isActive(mode.id),
                'blue-grey--text text--darken-1': !isActive(mode.id),
              }"
            >
              {{ mode.description }}
            </span>
          </div>
        </article>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ScoringModeSelector',

  props: {
    value: {
      type: String,
      default: null,
    },
  },

  computed: {
    modes() {
      return [
        {
          id: null,
          icon: 'mdi-cancel',
          title: this.$t('routines.scoring.no_scoring'),
          description: this.$t('routines.scoring.mode_no_scoring_description'),
        },
        {
          id: 'question',
          icon: 'mdi-list-status',
          title: this.$t('routines.scoring.mode_question_title'),
          description: this.$t('routines.scoring.mode_question_description'),
        },
        {
          id: 'section',
          icon: 'mdi-view-agenda-outline',
          title: this.$t('routines.scoring.mode_section_title'),
          description: this.$t('routines.scoring.mode_section_description'),
        },
      ]
    },
  },

  methods: {
    isActive(modeId) {
      return this.value === modeId
    },
  },
}
</script>

<style scoped lang="scss">
.scoring-mode-selector {
  padding-top: $space-2;
}

.mode-card {
  border-color: $color-blue-grey-lighten2 !important;
  background-color: $color-white;
  cursor: pointer;
}

.mode-card--active {
  border-color: $color-blue !important;
  background-color: $color-blue-lighten2 !important;
}

.mode-card__layout {
  min-height: 100px;
}

.mode-card__icon {
  width: 38px;
  height: 38px;
  border-radius: 4px;
  color: $color-blue-grey-darken1;
  background-color: $color-blue-grey-lighten1;
}

.mode-card__icon--active {
  color: $color-white;
  background-color: $color-blue;
}

.mode-card__content {
  flex: 1;
  min-width: 0;
}

.mode-card__content .text-caption {
  line-height: 1.35;
  word-break: break-word;
}
</style>
